import { Add } from "@mui/icons-material";
import {
  Box,
  Button,
  Card as MuiCard,
  CardContent,
  CircularProgress,
  Grid,
  Divider as MuiDivider,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { spacing } from "@mui/system";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DocumentoModale from "./Aggiungi&Modifica";
import Filters from "./Filters";
import { API_BASE_URL } from "../../../config";

const Card = styled(MuiCard)(spacing);

const Divider = styled(MuiDivider)(spacing);

function Documenti() {
  const [openModale, setOpenModale] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);
  const [allRows, setAllRows] = useState([]);
  const [rows, setRows] = useState([]);
  const [filtri, setFiltri] = useState({});
  const [iduid, setIduid] = useState("");

  const [pageSize, setPageSize] = useState(5);

  const navigate = useNavigate();

  const handleOpenModale = (iduid) => {
    setIduid(iduid);
    setOpenModale(true);
  };

  const columns = [
    {
      field: "nome",
      headerName: "Nome",
      minWidth: 275,
      flex: 1,
      renderCell: (params) => (
        <>
          <Box display="flex" flexDirection="column">
            <Typography
              fontWeight="bold"
              color="#407ad6"
              sx={{
                cursor: "pointer",
                ":hover": {
                  textDecoration: "underline",
                },
              }}
              onClick={() => handleOpenModale(params.row.iduid)}
            >
              {params.row.nome}
            </Typography>

            <Typography fontSize={10}>{params.row.tipologia}</Typography>
            <Typography fontSize={10}>{params.row.descrizione}</Typography>
          </Box>
        </>
      ),
    },
    {
      field: "tipo",
      headerName: "Tipo Documento",
      minWidth: 300,
      flex: 1,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <>
          <Box display="flex" flexDirection="column">
            <Typography fontWeight="bold">{params.row.tipo}</Typography>
            <Typography fontWeight="bold" fontSize={10}>
              {params.row.fonte}
            </Typography>
            {params.row.idfonte === 3 ? (
              <Typography fontSize={10}>{params.row.idUidFile}</Typography>
            ) : params.row.idfonte === 2 ? (
              <Typography fontSize={10}>{params.row.link}</Typography>
            ) : (
              <></>
            )}
          </Box>
        </>
      ),
    },
    {
      field: "utenteNominativo",
      headerName: "Creato da",
      minWidth: 250,
      flex: 1,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <>
          <Box display="flex" flexDirection="column">
            <Typography fontWeight="bold">
              {params.row.utenteNominativo}
            </Typography>

            <Typography fontSize={10}>{params.row.dataCreazione}</Typography>
          </Box>
        </>
      ),
    },
    {
      field: "utenteModifica",
      headerName: "Modificato da",
      minWidth: 250,
      flex: 1,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <>
          <Box display="flex" flexDirection="column">
            <Typography fontWeight="bold">
              {params.row.utenteModifica}
            </Typography>

            <Typography fontSize={10}>
              {params.row.dataUltimaModifica}
            </Typography>
          </Box>
        </>
      ),
    },
  ];

  async function documentiGetList() {
    const token = sessionStorage.getItem("token");
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          token,
          /*  data: {
            idUID: idUID === undefined ? "" : idUID,
          }, */
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/documentiGetList`,
        requestOptions
      );

      const responseData = await response.json();
      if (responseData.status === -1) {
        navigate("/auth/sign-in");
      }
      if (responseData.status === 0) {
        navigate("/private");
      }
      setAllRows(responseData.data.dataset);
      setRows(responseData.data.dataset);
      setFiltri({
        tipologie: responseData.data.tipologie,
        fonte: responseData.data.fonte,
        tipo: responseData.data.tipo,
      });
      setLoadingPage(false);
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  useEffect(() => {
    documentiGetList();
  }, []);

  const refreshDataGrid = () => {
    setLoadingPage(true);
    documentiGetList();
  };

  return (
    <>
      {loadingPage ? (
        <Box
          sx={{
            width: "calc(100vw - 40px)",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Helmet title="Documenti" />
          {openModale && (
            <DocumentoModale
              open={openModale}
              setOpen={setOpenModale}
              iduid={iduid} // Pass the iduid to the component
              onRefresh={refreshDataGrid}
            />
          )}
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h3" display="inline">
              Documenti
            </Typography>
            <Box display="flex" justifyContent="end" gap={4}>
              <Button
                mr={2}
                variant="contained"
                color="primary"
                onClick={() => handleOpenModale("")}
              >
                <Add />
              </Button>
            </Box>
          </Box>
          <Divider my={4} />
          <Grid container spacing={6}>
            <Grid item xs={12} mb={4}>
              <Filters filtri={filtri} allRows={allRows} setRows={setRows} />
            </Grid>
          </Grid>
          <Card>
            <CardContent pb={1}>
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  <Typography variant="h6" gutterBottom>
                    Risultati: {rows.length}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
            <Paper sx={{ width: "100%" }} mt={4}>
              <DataGrid
                columns={columns}
                rows={rows}
                getRowId={(row) => row.iduid}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[5, 10, 20]}
                pagination
                autoHeight
                disableSelectionOnClick
                components={{
                  NoRowsOverlay: () => (
                    <Stack
                      height="100%"
                      alignItems="center"
                      justifyContent="center"
                    >
                      No rows in DataGrid
                    </Stack>
                  ),
                }}
              />
            </Paper>
          </Card>
        </>
      )}
    </>
  );
}

export default Documenti;
